import { render, staticRenderFns } from "./RosetteRewardPopupContent.vue?vue&type=template&id=3dfb98a5&scoped=true&"
import script from "./RosetteRewardPopupContent.vue?vue&type=script&lang=js&"
export * from "./RosetteRewardPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./RosetteRewardPopupContent.vue?vue&type=style&index=0&id=3dfb98a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb98a5",
  null
  
)

export default component.exports